import React from "react";
import { Card, CardContent, Button, Typography, Box, ListItem } from "@mui/material";
import { GetNotificationDefinitionDto } from "../../api-client";
import FileCapture from "../DocumentUpload/capture/fileCapture/FileCapture";

interface NoticeRowProps {
  noticeDefinition: GetNotificationDefinitionDto;
  onDownload: () => void;
  onUpload: (file: File) => void;
}
// Individual Notice Component
const NoticeRow = ({ noticeDefinition, onDownload, onUpload }: NoticeRowProps) => {
  return (
    <ListItem>
      <Card variant="outlined" style={{ width: "100%" }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            {noticeDefinition.title}
          </Typography>
          <Typography variant="body2" color="textSecondary" paragraph>
            {noticeDefinition.description}
          </Typography>
          <Box display="flex" justifyContent="flex-end" gap={1} mt={2}>
            <Button variant="contained" color="primary" onClick={onDownload}>
              Download
            </Button>

            <FileCapture
              onCapture={(file: File) => {
                // setShowDocuTypeModal(true);
                // setFiles([file]);
                onUpload(file);
              }}
            />
          </Box>
        </CardContent>
      </Card>
    </ListItem>
  );
};

export default NoticeRow;
